<template>
<!-- 
El componente recibe un string separado por ','
La función computada lo convierte en un array
Se repite cada elemento basado en ese array
Se visualizan un máximo de 2 items declarados en el v-show
El botón solo se visualiza cuando la cantidad de items es superior a 2 del length del array
El botón y los chip abren un modal que contiene el listado completo del array
 -->
  <div>
    <v-chip-group v-model="selection" active-class="text--accent-4" :column="true">
      <v-chip v-for="(item , idx) in aDataChip"  :key="'item-'+idx" 
      v-show="idx < 2" :alt="'idprueba-'+idx" :value="item"
      @click="modal = true" class="chip-item my-1" small>
        {{ item }}
      </v-chip>
    </v-chip-group>
    <v-btn class="btn-mas" v-if="aDataChip.length > 2" text color="primary" x-small @click="modal = true">Ver más +</v-btn>
    <v-dialog v-model="modal" width="600px">
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>{{aDataChip.titulo}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="modal = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-2">
          <ul><li v-for="item in aDataChip" :key="item"> {{item}} </li></ul>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name:'CeldaChips',
  props:{
    texto:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selection: '',
      modal: false
    }
  },
  computed:{
    aDataChip(){
      return this.texto != null ? this.texto.split(',') : []
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-mas{
  display: block;
  margin: 0 auto;
}
.chip-item{
  font-size: 10px!important;
  min-width: 100px;
  // text-transform:lowercase!important;
}
</style>